import { Component, OnInit } from '@angular/core';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { BaseProductComponent } from '@product/shared/base-product.component';
import { catalog } from '@product/shared/models/catalog';
import { catchError, forkJoin, map, of, switchMap, tap } from 'rxjs';


@Component({
  selector: 'app-catalog-list',
  templateUrl: './catalog-list.component.html',
  styleUrls: ['./catalog-list.component.less']
})
export class CatalogListComponent extends BaseProductComponent implements OnInit {
  private objectUrls: Set<string> = new Set(); 
  url = AppConfigService.settings.baseUrl;
  shareableLink: string = '';
  catalogs: catalog[] = [];
  checked = false;
  indeterminate = false;
  selectedIds: Set<number> = new Set();
  isCardView: boolean = false;
  catalogImages = new Map<number, any>();
  objectType: number = 20;
  isLoading: boolean = false;
  imageSrc: any | null = null;
  ngOnInit() {
    this.getAllCatalog();
    
  
  }
  cardsParams = {
    currentPage: 1,
    pageSize: 10,
  };

  catalogTableParams = {
    index: 1,
    size: 10,
  };

  searchValue: string = '';
  displayedCatalog: catalog[] = [];
  isSearching: boolean = false;
  searchQuery: string = '';
  filteredCatalog: catalog[] = [];
  isCopied: { [key: number]: boolean } = {};
  listOfSelection = [
    {
      text: 'Select All Row',
      onSelect: () => {
        ;
        this.selectedIds = new Set(this.catalogs.map(catalog => catalog.id!));
        this.checked = true;

      }
    },

    {
      text: 'Select in Page',
      onSelect: () => {
        ;
        this.selectedIds = new Set(this.getPageData().map(catalog => catalog.id!));
        this.indeterminate = true;
        this.checked = true;
      }
    },

    {
      text: 'Deselect',
      onSelect: () => {
        this.selectedIds.clear();
        this.checked = false;
        this.indeterminate = false;
      }
    }
  ];

  onPageChange(pageIndex: number) {
    this.catalogTableParams.index = pageIndex;

  }
  
  getAllCatalog() {
    this.isLoading = true;
  
    this.productCatalog.getCatalogs().pipe(
      tap(() => this.catalogImages.clear()),
      switchMap((catalogs: any[]) => {
        this.catalogs = catalogs;
        this.catalogs.reverse();
        this.displayedCatalog = [...catalogs];
        this.filteredCatalog = [...catalogs];
        this.updatePagination();
  
        if (catalogs.length === 0) {
          this.isLoading = false;
          return of([]);
        }
  

        const requests = catalogs.map((catalog) => {
          if (catalog.thumbnailMediaObjectId) {
            return this.productCatalog.getImage({
              id: catalog.thumbnailMediaObjectId,
              catalogCode: catalog.catalogCode
            }).pipe(
              catchError(() => of(null)),
              map((blob) => ({ catalog, blob })) 
            );
          } else {
            return of({ catalog, blob: null }); 
          }
        });
  
  
        return forkJoin(requests).pipe(
          tap((results) => {
            results.forEach(({ catalog, blob }) => {
              if (blob) {
                const objectUrl = URL.createObjectURL(blob);
                 this.objectUrls.add(objectUrl);
                const safeUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
                this.catalogImages.set(catalog.id, safeUrl);
              }
            });
  
          
            const imagesObject: { [key: string]: any } = {};
            this.catalogImages.forEach((value, key) => {
              imagesObject[key] = value;
            });
          })
        );
      })
    ).subscribe({
      next: () => {
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching catalogs:', error);
        this.isLoading = false;
      }
    });
  }
  
  
  // getAllCatalog() {
  //   this.isLoading = true;

  //   this.productCatalog.getCatalogs().pipe(
  //     tap(() => this.catalogImages.clear()),
  //     switchMap((catalogs: any[]) => {
  //       this.catalogs = catalogs;
  //       this.catalogs.reverse();
  //       this.displayedCatalog = [...catalogs];
  //       this.filteredCatalog = [...catalogs];
  //       this.updatePagination();

  //       if (catalogs.length === 0) {
  //         this.isLoading = false;
  //         return of([]);
  //       }
       
  //       const requests = catalogs.map((catalog) =>
  //         this.productCatalog.getMedia(0, this.objectType, catalog.id).pipe(
  //           catchError(() => of([]))
  //         )
  //       );
  //       // const requests = catalogs.map((catalog) =>
  //       //   this.productCatalog.getImage({
  //       //     id: catalog.thumbnailMediaObjectId,
  //       //     catalogCode: catalog.catalogCode
  //       //   })
  //       // );
        
  //       return forkJoin(requests).pipe(
  //         tap((results) => {
         
            
  //           results.forEach((mediaData: any, index: number) => {
           
              
  //             if (mediaData.length > 0) {
  //               const {thumbUrl,bannerUrl, } = this.productCatalog.processMediaData(
  //                 mediaData,
  //                 catalogs[index].thumbnailMediaObjectId,
  //                 catalogs[index].bannerMediaObjectId,
              
  //               );
                
  //               this.catalogImages.set(catalogs[index].id, { thumbUrl,bannerUrl, });
  //               //this.catalogImages.set(catalogs[index].id, mediaData[0].fullPath)
  //             }
  //           });
  //         })
  //       );
  //     })
  //   ).subscribe({
  //     next: () => this.isLoading = false,
  //     error: (error) => {
  //       console.error('Error fetching catalogs:', error);
  //       this.isLoading = false;
  //     }
  //   });
  // }



  deleteCatalog(catalogId: any) {
    this.productCatalog.deleteCatalog(catalogId).subscribe({
      next: (response) => {
        this.message.success('Catalog deleted successfully');
        this.displayedCatalog = this.displayedCatalog.filter(catalog => catalog.id !== catalogId);
      },
      error: (error) => {
        this.message.error('Error deleting catalog')
      }
    });

  }


  copyToClipboard(id: number, catalogCode: string, catalogName: string) {
    const basePath: string = "/product-catalog/catalog-cards/";
    const url = `${window.location.origin}${basePath}${id}/${catalogCode}?catalogName=${catalogName}`;
    this.shareableLink = url;
    navigator.clipboard.writeText(this.shareableLink).then(() => {
      this.isCopied[id] = true;
      this.message.success('Link copied to clipboard');
      setTimeout(() => {
        this.isCopied[id] = false;
      }, 1000);
    }, err => {
      this.message.error('Failed to copy');
    });
  }




  getPageData(): any[] {
    const start = (this.catalogTableParams.index - 1) * this.catalogTableParams.size;
    const end = start + this.catalogTableParams.size;
    return this.catalogs.slice(start, end);
  }

  onSearch() {
    const searchValue = this.searchValue?.toLowerCase().trim().replace(/\s+/g, "");
    this.filteredCatalog = searchValue
      ? this.catalogs.filter((catalog: any) =>
        catalog?.name?.toLowerCase().replace(/\s+/g, "").includes(searchValue)
      )
      : this.catalogs;

    this.cardsParams.currentPage = 1;
    this.updatePagination();
  }


  onPageChangeCards(page: number) {
    this.cardsParams.currentPage = page;
    this.updatePagination();
  }

  updatePagination() {
    const startIndex = (this.cardsParams.currentPage - 1) * this.cardsParams.pageSize;
    const endIndex = startIndex + this.cardsParams.pageSize;

    this.displayedCatalog = this.filteredCatalog.slice(startIndex, endIndex);


  }
  goToEditCatalog(catalog: any): void {
    this.router.navigate(
      ['/product-catalog/manage-catalog', catalog.id, catalog.catalogCode],
      {
        queryParams: { catalogName: catalog.name }
      }
    );
  }
 override ngOnDestroy(): void {
     this.objectUrls.forEach(url => URL.revokeObjectURL(url));  
    this.objectUrls.clear();
 } 
}


